import { OvErrorBoundary, OvModal } from '@components'
import { KEYS, URL_PATHS } from '@constants'
import { saveToStorage } from '@helpers/storage.helpers'
import { useStore } from '@hooks/useStore'
import { observer } from 'mobx-react-lite'
import { Navigate, Outlet, ScrollRestoration, useLocation } from 'react-router-dom'

export const DefaultWithoutMenu = observer(() => {
  const { auth } = useStore()
  const location = useLocation()

  // Only check authentication, not company status
  // This layout is used for onboarding where users might not have a company yet
  if (!auth.is_authenticated) {
    // Store the full URL (including query parameters) to redirect back after login
    const intendedUrl = location.pathname + location.search
    saveToStorage(KEYS.INTENDED, intendedUrl)
    return <Navigate to={URL_PATHS.LOGIN} />
  }

  return (
    <>
      <ScrollRestoration />
      <main>
        <OvErrorBoundary>
          <Outlet />
        </OvErrorBoundary>
      </main>
      <OvModal />
    </>
  )
})
